import type { IGuestUser, IItem, INewQuote, IPrivacy } from '@/types';
import i18next from 'i18next';
import type { IAuctionHouseInfo, IShippingFormFields } from '../types';

export const isCategoryWithFragility = (category: string): boolean => category === 'e';

export const buildNewQuote = (
  user: IGuestUser,
  auctionHouse: IAuctionHouseInfo,
  shippingInfo: IShippingFormFields,
  privacy: IPrivacy
): INewQuote => {
  const { couponCode = '', hasItemData, item, myFile, ...ah } = auctionHouse;
  const { extraServices, recipient: name, store, ...recipient } = shippingInfo;

  return {
    auctionHouse: {
      ...ah,
    },
    couponCode,
    customer: {
      ...user,
      locale: i18next.languages[0],
    },
    extraServices: {
      packaging: {
        isIncluded: false,
        isRemovable: true,
      },
      safeValue: {
        isIncluded: false,
        isRemovable: true,
        isVisible: false,
      },
      safeValueArt: {
        isIncluded: false,
        isRemovable: true,
        isVisible: false,
      },
      signatureRequired: {
        isIncluded: false,
        isRemovable: true,
      },
    },
    item: {
      ...(hasItemData && (item as IItem)),
      ...extraServices,
      proofOfPurchaseFileName: myFile[0]?.id || '',
    },
    hasItemData,
    privacy,
    recipient: {
      ...recipient,
      name,
    },
    storeId: store.id,
  };
};
